import { render, staticRenderFns } from "./el-lottie.vue?vue&type=template&id=cdefce14&"
import script from "./el-lottie.vue?vue&type=script&lang=js&"
export * from "./el-lottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports